import { modal } from '../common/_modal';
import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

export const itemFunc = () => {
  // モーダルウィンドウ
  modal();

  /**
   * ウェディングドレスのスライダー
   */
  {
    const $sliderArr = [...document.querySelectorAll('.js-item-slider')];
    const halfLength = $sliderArr.length / 2;

    const param = {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        clickable: true,
        el: '.swiper-pagination',
      },
    };

    const mainParam = {
      slidesPerGroup: 2,
      slidesPerView: 2,
      spaceBetween: 20,
    };

    const modalParam = {
      breakpoints: {
        768: {
          slidesPerGroup: 2,
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    };

    const swiperArr = $sliderArr.map(($slider, i) => {
      const add = halfLength > i ? mainParam : modalParam;
      return new Swiper($slider, { ...param, ...add });
    });

    swiperArr.forEach((swiper, i) => {
      i = halfLength > i ? halfLength + i : i - halfLength;
      swiper.controller.control = swiperArr[i];
    });
  }
};
